import {Component, ContentChild, OnInit, TemplateRef} from '@angular/core';
import {User} from '@capacitor-firebase/authentication';
import {Store} from '@ngrx/store';
import {selectUser} from 'gamesis-state';
import {Observable} from 'rxjs';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'userInfo',
    template: `
        <ng-template [ngTemplateOutlet]="templ" [ngTemplateOutletContext]="{userInfo: user$}"></ng-template>
    `,
    imports: [CommonModule]
})
export class UserInfoComponent implements OnInit {
    @ContentChild(TemplateRef, {static: true}) templ;
    public user$: Observable<User>;

    constructor(private store: Store) {
    }

    ngOnInit() {
        this.user$ = this.store.select(selectUser);
    }
}
